<template>
  <div class="dolu_vic">

      <div class="row dolu_min">
          <div class="col-12">
              <card plain>

                <div class="row">
                  <div class="col-12">
                    <h4 class="hesla">Important sources:</h4>
                  </div>

                  <div class="col-3">
                    <a class="" aria-label="logo" href="https://virus.img.cas.cz/" target="_blank">
                      <div class="logo-img">
                          <img src="/img/logo_img.png" alt="">
                      </div>
                    </a>
                  </div>

                  <div class="col-3">
                    <a class="" aria-label="logo" href="https://cov-lineages.org/index.html" target="_blank">
                      <div class="logo-img">
                          <img src="/img/pango.png" alt="">
                      </div>
                    </a>
                  </div>

                  <div class="col-3">
                    <a class="" aria-label="logo" href="https://clades.nextstrain.org/" target="_blank">
                      <div class="logo-img">
                          <img src="/img/nextclade.png" alt="">
                      </div>
                    </a>
                  </div>

                  <div class="col-3">
                    <a class="" aria-label="logo" href="https://www.gisaid.org/" target="_blank">
                      <div class="logo-img">
                          <img src="/img/gisaid.png" alt="">
                      </div>
                    </a>
                  </div>

                </div>
              </card>
          </div>
      </div>



  </div>
</template>
<script>
  import { Card  } from 'element-ui'

  export default {
    components: {
      Card,
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {


      }
    }
  }

</script>
<style scoped>
  .main-panel {
    padding-top: 90px !important;
    padding-left: 220px !important;
  }

  .main-panel > .content {
      min-height: calc(100vh - 10px) !important;
  }

.el-card {
  border: 0px !important;
}

.bg-transparent {
  background-color: transparent !important;
  
}


.bold-text {
  font-weight: 900;
}


.logo-img {
  height: 100px !important;
}

.vyska {
  min-height: 400px !important;
}

.dolu_vic {
  padding-top: 80px !important;
  padding-right: 220px !important;
}

.dolu_min {
  padding-top: 25px !important;
}

</style>
